import { createSafeContext } from 'core/Utils';

type CreditDesignationContext = {
  rootContainerRef: React.RefObject<HTMLDivElement>;
};

export const [CreditDesignationProvider, useCreditDesignationContext] =
  createSafeContext<CreditDesignationContext>(
    'CreditDesignationContext component was not found in tree'
  );
